<div class="section-header">
    <h2>{{ 'courses.form.modules' | translate }}</h2>
    <p-button
        [label]="'courses.modules.add' | translate"
        icon="pi pi-plus"
        [outlined]="true"
        size="small"
        [attr.data-test]="testId() + '-add'"
        (onClick)="add.emit()"
    />
</div>

@if (modules().length > 0) {
    <div cdkDropList class="module-list" (cdkDropListDropped)="onDrop($event)">
        @for (module of modules(); track module.id) {
            <div cdkDrag class="module-item">
                <div class="arrows">
                    <button
                        type="button"
                        class="arrow"
                        [disabled]="$first"
                        [attr.data-test]="testId() + '-move-up-' + module.id"
                        (click)="moveModule($index, -1)"
                    >
                        <i class="pi pi-chevron-up"></i>
                    </button>
                    <button
                        type="button"
                        class="arrow"
                        [disabled]="$last"
                        [attr.data-test]="testId() + '-move-down-' + module.id"
                        (click)="moveModule($index, 1)"
                    >
                        <i class="pi pi-chevron-down"></i>
                    </button>
                </div>
                <span class="name">{{ module.name }}</span>
                <button type="button" class="remove" [attr.data-test]="testId() + '-remove-' + module.id" (click)="remove.emit(module.id)">
                    <i class="pi pi-trash"></i>
                </button>
            </div>
        }
    </div>
} @else {
    <p class="empty">{{ 'courses.modules.empty' | translate }}</p>
}
